import { Button, Typography } from '@mui/material'
import { FC } from 'react'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { useUserStore } from '../../store/storeUser'
import { useWrapperStore } from '../../store/storeWrapper'

type Props = {
    open: boolean
    onClose: VoidFunction
    onSubmit: VoidFunction
    nextPaymentDate: string | null
    currentTariffTitle?: string | null
    newTariffTitle?: string | null
}

const mapOnboarding = {
    1: {
        image: '/Onboarding1.png',
        title2: 'Автопилот',
        text: 'Сам выбирает подходящую модель под ваш запрос. Не нужно разбираться — всё делается автоматически, но можно выбрать любую модель или ассистента',
    },
    2: {
        image: '/Onboarding2.png',
        title2: 'Ассистенты',
        text: 'Более 20 готовых чат-ботов экспертов с ролями (репетитор, фитнес-тренер, нутрициолог, психолог и др.). Они сразу работают для тебя без сложных настроек',
    },
    3: {
        image: '/Onboarding3.png',
        title2: 'Коины',
        text: 'Мы подарили вам 250 коинов для старта. Баланс можно пополнять, когда понадобится',
    },
    4: {
        image: '/Onboarding4.png',
        title2: 'Проекты',
        text: 'Объединяют запросы, файлы и инструкции в одном месте. Контекст сохраняется и учитывается в работе',
    },
    5: {
        image: '/Onboarding5.png',
        title2: 'Первый запрос',
        text: 'Введите запрос в строку и начните пользоваться сервисом, можете вложить файл, включить WEB-поиск, настроить, выбрать проект или ничего этого не делать',
    },
}

export const OnboardingStep: FC<Props> = ({ open }) => {
    const { stepOnboarding, dialogsOpen, setStepOnboarding, setDialogsOpen } = useWrapperStore((state) => state)
    const { userPersonalData, updateUserPersonalData } = useUserStore()

    const handleClick = async () => {
        if (stepOnboarding === 5) {

            setStepOnboarding(100)
            setDialogsOpen(true)

        } else {
            setStepOnboarding(stepOnboarding + 1)
        }
        await updateUserPersonalData({ banners: { [`step_onboarding_${stepOnboarding}`]: true } }, false)

    }

    const handleClickSkip = () => {
        setStepOnboarding(100)
        const banners = {}

        for (let i = stepOnboarding; i < 6; i++) {
            banners[`step_onboarding_${i}`] = true
        }

        updateUserPersonalData({ banners }, false)
        setDialogsOpen(true)
    }

    return (
        <ModalDialogWrapper
            open={open}
            handleClose={handleClick}
            title="Что умеет наш сервис?"
            footerActions={
                <>
                    {stepOnboarding === 5 ? (
                        <Button variant="contained" fullWidth onClick={handleClick}>
                            Готово
                        </Button>
                    ) : (
                        <>
                            <Button variant="outlined" onClick={handleClickSkip} fullWidth>
                                Пропустить
                            </Button>
                            <Button variant="contained" fullWidth onClick={handleClick}>
                                Дальше
                            </Button>
                        </>
                    )}
                </>
            }>
            <img
                style={{
                    height: ' 180px',
                    width: '343px',
                }}
                src={mapOnboarding[stepOnboarding]?.image}
            />
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: '600' }}>
                {mapOnboarding[stepOnboarding]?.title2}
            </Typography>
            <Typography variant="body1">{mapOnboarding[stepOnboarding]?.text}</Typography>
            <Typography variant="body2" color="#5A5C5E" sx={{}} mt={1}>
                {stepOnboarding} из 5
            </Typography>
        </ModalDialogWrapper>
    )
}
